import React from 'react';

import {
  AA_MONOMER_LIBRARY_URL,
  TEMPLATE_BULK_AA_MONOMERS_CSV_LINK,
} from 'molbio/aa-monomers/AaMonomerConstants';
import {createAaMonomersFromFile, validateAaMonomersFromFile} from 'molbio/aa-monomers/AaMonomersDAO';
import {useCanCreateAaMonomersAndRedirect} from 'molbio/aa-monomers/admin/useCanCreateAaMonomers';
import SharedMonomerConfigurationPageContainer, {
  MONOMER_CONFIGURATION_PURPOSE,
} from 'molbio/monomers/admin/SharedMonomerConfigurationPageContainer';
import SharedMonomerCreateFromCSVPage from 'molbio/monomers/admin/SharedMonomerCreateFromCSVPage';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

export default function AaMonomerCreateFromCSVPage(): JSX.Element | null {
  const {isLoading} = useCanCreateAaMonomersAndRedirect();

  if (isLoading) {
    return <CenteredHorizontalThrobber />;
  }

  return (
    <SharedMonomerCreateFromCSVPage
      pageContainer={
        <SharedMonomerConfigurationPageContainer
          purpose={MONOMER_CONFIGURATION_PURPOSE.CREATE}
          methodTitle="Upload CSV"
          libraryName="AA Monomer library"
          libraryUrl={AA_MONOMER_LIBRARY_URL}
          changeMethodUrl="/aa-monomers/create"
        />
      }
      libraryUrl={AA_MONOMER_LIBRARY_URL}
      // Keep in sync with _REQUIRED_COLUMNS/_ALLOWED_COLUMNS in
      // benchling/molbio/aa_monomers/connectors/csv_util.py
      bannerText='The CSV file must define “name”, “symbol”, "smiles", “naturalAnalog", and "color" columns. It can also include an optional "customMolecularWeight" column.'
      bannerSupportingInfo="Acceptable natural analog values are the single-letter amino acid codes."
      templateCsvLink={TEMPLATE_BULK_AA_MONOMERS_CSV_LINK}
      validate={validateAaMonomersFromFile}
      createFromFile={async (url, filename) =>
        (await createAaMonomersFromFile(url, filename)).createdIds.length
      }
      dataTestComponent="AaMonomerCreateFromCSVPage"
    />
  );
}
